import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import api from '~/api/pipelines';

type PipelineOptionsVariables = {
  realm: string;
  size: number;
  search: { name?: string; page: number };
};

export const usePipelineOptions = () => {
  const queryClient = useQueryClient();

  const fetchPipelineOptions = useCallback(
    (variables: PipelineOptionsVariables) =>
      queryClient.fetchQuery({
        queryKey: [
          'run',
          'pipelineOptions',
          variables.realm,
          variables.search.name,
          variables.search.page
        ],
        queryFn: () => api.fetch(variables),
        staleTime: 0,
        gcTime: 0
      }),
    [queryClient]
  );

  return { fetchPipelineOptions };
};
